
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AffiliateLink extends Vue {
  @Prop({ type: String, default: "" }) public referralLink!: string;
}
